<template>
  <VoiceVoiceDesigner />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
